import { useRef, useEffect } from 'react';
import * as d3 from 'd3';

const N = 27;
const width = 800;
const height = 800;
const radius = 300;

function D3Chart() {
  const ref = useRef(null);

  useEffect(() => {
    const svg = d3.select(ref.current);
    svg.selectAll("*").remove(); // 清空

    // 畫主圓
    svg.append("circle")
      .attr("cx", width/2)
      .attr("cy", height/2)
      .attr("r", radius)
      .attr("fill", "none")
      .attr("stroke", "#222")
      .attr("stroke-width", 2);

    // 主刻度
    for (let i = 0; i < N; i++) {
      const angle = ((i - 12) * 2 * Math.PI) / N - Math.PI/2;
      const x1 = width/2 + Math.cos(angle) * radius;
      const y1 = height/2 + Math.sin(angle) * radius;
      const x2 = width/2 + Math.cos(angle) * (radius - 10);
      const y2 = height/2 + Math.sin(angle) * (radius - 10);

      svg.append("line")
        .attr("x1", x1)
        .attr("y1", y1)
        .attr("x2", x2)
        .attr("y2", y2)
        .attr("stroke", "#222")
        .attr("stroke-width", 2);

      if (i < 25) {
        const labelAngle = angle;
        const labelRadius = radius + 20;
        const lx = width/2 + Math.cos(labelAngle) * labelRadius;
        const ly = height/2 + Math.sin(labelAngle) * labelRadius + 5;
        svg.append("text")
          .attr("x", lx)
          .attr("y", ly)
          .attr("text-anchor", "middle")
          .attr("font-size", 14)
          .attr("fill", "#222")
          .text(i.toString().padStart(1, '0'));
      }
    }

    // 副刻度
    for (let i = 0; i < N; i++) {
      const angle = (((i + 0.5) - 12) * 2 * Math.PI) / N - Math.PI/2;
      const x1 = width/2 + Math.cos(angle) * radius;
      const y1 = height/2 + Math.sin(angle) * radius;
      const x2 = width/2 + Math.cos(angle) * (radius - 10);
      const y2 = height/2 + Math.sin(angle) * (radius - 10);

      svg.append("line")
        .attr("x1", x1)
        .attr("y1", y1)
        .attr("x2", x2)
        .attr("y2", y2)
        .attr("stroke", "#222")
        .attr("stroke-width", 2);
    }

  }, []);

  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      style={{
        background: "#fff",
        pointerEvents: "none",
      }}/>
  );
}

export default D3Chart;